import { z } from "zod";
import { CompanySchema } from "./Company";
import { UserSchema } from "./User";

export const DocumentInvoiceFieldsSchema = z.object({
  id: z.number().int(),
  importId: z.string(),
  importCode: z.string(),
  importTyp: z.string(),
  documentDate: z.string(),
  valueNettoBeforeDiscount: z.number(),
  valueNetto: z.number(),
  valueBrutto: z.number(),
  valueVat: z.number(),
  address: z.string(),
  description: z.string(),
  documentHeader: z.string(),
  paymentToPay: z.number(),
  paymentPayed: z.number(),
  paymentDate: z.string(),
  addressCustomer: z.string(),
  addressDelivery: z.string(),
  addressOwner: z.string(),
  documentType: z.number(),
  incomeValue: z.number(),
  outcomeValue: z.number(),
  externalNumber: z.string(),
  companyName: z.string(),
  defaultAddress: z.string(),
  nip: z.string(),
  currencyCode: z.string(),
  isReceipt: z.boolean(),
  documentStatus: z.number().int(),
  isAccounted: z.boolean(),
  documentSubtype: z.string(),
  modificationDate: z.string(),
  createdAt: z.string(),
  exchange: z.any(),
  exchangeRatio: z.number(),
  userPhName: z.string(),
  vatConversionMode: z.number().int(),
  connectedEmailStatus: z.number().int(),
  company: CompanySchema,
  paymentType: z.any(),
  reciver: UserSchema,
  creatorUser: UserSchema,
  storehouse: z.any(),
  documentSeriesDefinition: z.any(),
  positions: z.any(),
  userPh: UserSchema,
});
export const PartialDocumentInvoiceFieldsSchema =
  DocumentInvoiceFieldsSchema.deepPartial();

export const DocumentInvoiceExtraFieldsSchema = z.object({
  attributes: z.array(z.any()),
  creator: z.any(),
  availableTemplates: z.any(),
  ksefNumber: z.any(),
});
export const PartialDocumentInvoiceExtraFieldsSchema =
  DocumentInvoiceExtraFieldsSchema.deepPartial();

export const DocumentInvoiceSchema = z.intersection(
  DocumentInvoiceFieldsSchema,
  DocumentInvoiceExtraFieldsSchema
);

export type DocumentInvoiceFields = z.infer<typeof DocumentInvoiceFieldsSchema>;
export type PartialDocumentInvoiceFields = z.infer<
  typeof PartialDocumentInvoiceFieldsSchema
>;
export type DocumentInvoiceExtraFields = z.infer<
  typeof DocumentInvoiceExtraFieldsSchema
>;
export type PartialDocumentInvoiceExtraFields = z.infer<
  typeof PartialDocumentInvoiceExtraFieldsSchema
>;
export type DocumentInvoice = z.infer<typeof DocumentInvoiceSchema>;
